import { srOnlyElement, srOnlySpan } from '../../utils/screen-reader/html';
import type SyosSeat from '../SyosSeat';

export default function render(seat: SyosSeat) {
  const headingId = `tn-syos-seat-info-heading-${seat.id}`;

  return `<div class="tn-syos-seat-info__header">
    ${srOnlyElement('div', '<h2>Seat Information</h2>', { id: headingId })}
      <ul class="tn-syos-seat-info__table" aria-labelledby="${headingId}">
        <li class="tn-syos-seat-info__column">
          <div class="tn-syos-seat-info__cell-header" role="none">
            Section
            ${srOnlySpan(': ')}
          </div>
          <div class="tn-syos-seat-info__cell tn-syos-seat-info__seat-description" role="none">${seat.sectionDescription}</div>
        </li>
        <li class="tn-syos-seat-info__column">
          <div class="tn-syos-seat-info__cell-header" role="none">
            Row
            ${srOnlySpan(': ')}
          </div>
          <div class="tn-syos-seat-info__cell tn-syos-seat-info__seat-row" role="none">${seat.row}</div>
        </li>
        <li class="tn-syos-seat-info__column">
          <div class="tn-syos-seat-info__cell-header" role="none">
            Seat
            ${srOnlySpan(': ')}
          </div>
          <div class="tn-syos-seat-info__cell tn-syos-seat-info__seat-number" role="none">${seat.number}</div>
        </li>
        ${renderSeatDescription(seat)}
      </ul>
    </div>`;
}

function renderSeatDescription(seat: SyosSeat) {
  if (!seat.description) {
    return '';
  }

  return `<li class="tn-syos-seat-info__row">
    <div class="tn-syos-seat-info__seat-type">${seat.description}</div>
  </li>`;
}
